export default "__VITE_ASSET__B3NHAld9__"